import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currencySymbol: { type: String, default: "\u00A3" },
    activeUnit: { type: Number, default: 4 },
    inactiveUnit: { type: Number, default: 1 },
    initialTotal: { type: Number, default: 10 },
    initialScheduled: { type: Number, default: 4 }
  }

  static targets = [
    "totalVal",
    "activeVal",
    "activeLabel",
    "activeCost",
    "inactiveLabel",
    "inactiveCost",
    "totalCost",
    "savingText",
    "savingDetail"
  ]

  connect() {
    this.total = this.initialTotalValue
    this.active = this.initialScheduledValue
    this.calcTime()
  }

  // ── Time calculator ──
  adjustTotal(event) {
    const delta = parseInt(event.params.delta)
    this.total = Math.max(1, Math.min(100, this.total + delta))
    this.active = Math.min(this.active, this.total)
    this.calcTime()
  }

  adjustActive(event) {
    const delta = parseInt(event.params.delta)
    this.active = Math.max(0, Math.min(this.total, this.active + delta))
    this.calcTime()
  }

  calcTime() {
    if (!this.hasTotalValTarget) return

    const sym = this.currencySymbolValue
    const activeRate = this.activeUnitValue
    const inactiveRate = this.inactiveUnitValue
    const inactive = Math.max(0, this.total - this.active)
    const activeCost = this.active * activeRate
    const inactiveCost = inactive * inactiveRate
    const totalCost = activeCost + inactiveCost
    const fullCost = this.total * activeRate
    const saving = fullCost - totalCost

    this.totalValTarget.textContent = this.total
    this.activeValTarget.textContent = this.active
    this.activeLabelTarget.textContent = `${this.active} scheduled \u00D7 ${sym}${activeRate}`
    this.activeCostTarget.textContent = `${sym}${activeCost}`
    this.inactiveLabelTarget.textContent = `${inactive} unscheduled \u00D7 ${sym}${inactiveRate}`
    this.inactiveCostTarget.textContent = `${sym}${inactiveCost}`
    this.totalCostTarget.textContent = `${sym}${totalCost}`

    if (saving > 0) {
      const pct = Math.round((saving / fullCost) * 100)
      this.savingTextTarget.textContent = `You're saving ${sym}${saving}/mo with dynamic pricing (${pct}% less)`
      this.savingTextTarget.style.display = 'block'
      if (this.hasSavingDetailTarget) {
        this.savingDetailTarget.textContent = `Most providers charge a flat ${sym}${activeRate}/employee regardless of hours worked \u2014 that would cost you ${sym}${fullCost}/mo. With GoodEvent Time, unscheduled crew drop to just ${sym}${inactiveRate}/mo. You only pay full price for the people actually on shift.`
        this.savingDetailTarget.style.display = 'block'
      }
    } else {
      this.savingTextTarget.style.display = 'none'
      if (this.hasSavingDetailTarget) {
        this.savingDetailTarget.style.display = 'none'
      }
    }
  }
}
